import { mapState } from 'vuex';

import f from "@/application/shared/functions.js";
import chatevent from "./chatevent/index.vue";


export default {
    name: 'chat',
    props: {
        id : String,
        view : String,
        context : String
    },

    components : {
        chatevent
    },

    data : function(){

        return {
            loading : false,
            lastScroll : 0,
            rendered : false,
            focused : null,
            observer : null,
            end : false,
            DAdestroy : null,
            displayCount : 0
        }

    },

    created (){
        
    },

    beforeDestroy (){



        this.destroy()
    },

    watch: {
        //$route: 'getdata'
       

        unreadMessageId : {
            //immediate : true,
            handler : function(){
                setTimeout(() => {

                    /*if(!this.playingstory){
                        this.scrollToEvent(this.unreadMessageId ? this.unreadMessageId : 'end')
                    }*/
                    
                    //this.scrollToEnd(this.unreadMessageId ? 0 : 0)

                }, 200)
            }
        },

        focusedEvent : function(){

            if(!this.rendered) return

            this.$store.commit('delayedAction', null)

            this.read()
        },

        id : {
            immediate : true,
            handler : function(){
                this.destroy()
                this.create()
            }
        },

        filteredEvents : {
            handler : function(){
                console.log('createObserver')
                this.$nextTick(() => {
                    this.createObserver()
                })
                
            }
        }

        
    },
    computed: mapState({

        playlist : state => {
            return state.playlist
        },

        storyview : function(){
            if(this.view == 'storyview') return 'storyview'
        },

        page: function(){
            /*if(this.storyview){
                return 5
            }*/

            return 50
        },

        modals : state => state.modals,

        android : function(){
            return window.cordova && !f.isios()
        },
        playingstory : state => state.playingstory,
        auth : state => state.auth,

        chat : function(state){

            return this.core.chats.helpers.getChatForUser(state.userinfo.userinfo.id, this.id)
        },

        mobileview : state => state.mobileview,

        events: function(){
            return _.first(this.chat.events, this.displayCount)
        },

        filteredEvents : function(){
            var chatEvents =  _.filter(this.events, (e) => {
                return e.type == 'message' && !e.removed
            })

            var systemEventsBefore = []
            var systemEventsAfter = []

            if(this.context == 'bot'){
                if (this.end){
                    systemEventsAfter.unshift({
                        type : 'message',
                        uid : 'intro',
                        system : true,
                        data : {
                            type : 'system',
                            text : 'system2',
                            template : 'intro'
                        }
                    })
                }
    
                
    
                systemEventsBefore.push({
                    type : 'message',
                    uid : 'last',
                    system : true,
                    data : {
                        type : 'system',
                        text : 'system',
                        template : 'last'
                    }
                })
            }

            if(this.context == 'support'){
                if (!this.events.length){
                    systemEventsAfter.unshift({
                        type : 'message',
                        uid : 'intro',
                        system : true,
                        data : {
                            type : 'system',
                            text : 'system2',
                            template : 'support'
                        }
                    })
                }
            }

            return systemEventsBefore.concat(chatEvents.concat(systemEventsAfter))
        },

        filteredUnsystemEvents : function(){

            return _.filter(this.filteredEvents, (e) => {
                return !e.system && e.type == 'message'
            })
        },

        unreadMessageId : function(){

            var me = this.core.user.info.userinfo.id
            
            var fe = _.find(([].concat(this.filteredUnsystemEvents)).reverse(), (e) => {

                var byme = e.creator == me

                return !e.read && !byme
            })

            if (fe){

                return fe.uid
            }

            return null
        },

        unreadCount : function(){

            var fe = _.filter(this.filteredUnsystemEvents, (e) => {
                return !e.read
            })

            return fe.length
        },

        toBottomButton : function(){

            var eventId = ''

            if (this.focused && this.view == 'storyview'){
                var i = _.findIndex(this.filteredUnsystemEvents, (fe) => {return fe.uid == this.focused})


                if (i > 0){
                    eventId = this.filteredUnsystemEvents[0].uid //this.filteredEvents[i - 1].uid
                }
                
            }

            return eventId
        },

        focusedEvent : function(){
            return _.find(this.filteredEvents, (fe) => {return fe.uid == this.focused})
        },

        toTopButton : function(){

            var eventId = 'start'

            if (this.focused && this.view == 'storyview'){
                var i = _.findIndex(this.filteredEvents, (fe) => {return fe.uid == this.focused})

                if (i < this.filteredEvents.length - 1){
                    eventId = this.filteredEvents[i + 1].uid
                }
            }

            return eventId
        }
    }),

    methods : {

        read : function(){
            if(this.focusedEvent && !this.focusedEvent.read && !this.focusedEvent.byme){

                var me = this.core.user.info.userinfo.id
                var byme = this.focusedEvent.creator == me

                if(!byme){
                    this.core.chats.api.read([this.id]).then(() => {
                    })
                }
            }
        },

        create : function(){
            

            this.loading = false
            this.lastScroll = 0
            this.rendered = false
            this.focused = null
            this.observer = null
            this.end = false

            this.displayCount = 0

            setTimeout(() => {
                

                this.loadEvents().then(() => {
                    //this.scrollToEnd(0)
                    this.scrollToEvent(this.unreadMessageId ? this.unreadMessageId : 'end')
                    
                    this.createObserver()

                    setTimeout(() => {

                        this.rendered = true
                        
                        this.read()

                    }, 200)
                })

            }, 20)
        },

        destroy : function(){
            this.displayCount = 0
            this.destroyObserver()
            this.$store.commit('delayedAction', null)
        },

        needload : function(){
            if(this.end) return
            if(this.loading) return
            if(!this.$refs['events']) return
            if(!this.rendered) return

            if(this.$refs['events'].scrollTop - this.$refs['events'].clientHeight < 0){
                return true
            }

            return false
        },

        loadEvents : function(){
            var from = this.events[this.events.length -1]?.id
            var count = this.page
            var chat = this.chat

            this.loading = true
            
            console.log('loadEvents')

            return this.core.chats.api.getEvents(chat, from, count).then(({events, end}) => {

            console.log('loadEventsend', end)


                this.displayCount = this.displayCount + count

                //this.events = this.events.concat(events)
                this.end = end
            }).catch(e => {
                console.error(e)
            }).finally(() => {

                setTimeout(() => {
                    this.loading = false
                }, 1000)
                
            })
        },

        bottomScrollButton : function(){

            this.scrollToEvent(this.toBottomButton)
        },

        topScrollButton : function(){

            this.scrollToEvent(this.toTopButton)
        },

        scrollToEvent : function(eventId){

            console.log("SCROLL TO EVENT")

            if(!eventId) return

            if(eventId == 'end') return this.scrollToEnd()
            if(eventId == 'start') return this.scroll(0)

            var r = this.$refs['event_wrapper_' + eventId]


            if (r){

                const container = this.$refs["events"];

                if(!container) return

                this.scroll(r[0].offsetTop)
            }

        },

        destroyObserver : function() {
            if (this.observer){
                this.observer.disconnect()
                this.observer = null
            }
        },

        createObserver : function() {

            if(!this.$refs.chatroot) return

            this.destroyObserver()

            this.observer = new IntersectionObserver((entries) => {

                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.focused = entry.target.getAttribute('uid')
                    }
                });
                },
                {
                    root : this.$refs.chatroot,
                    threshold: 0.5
                }
            );
          
            const sections = this.$refs.chatroot.querySelectorAll(".ewrapper");

            sections.forEach((section) => this.observer.observe(section));
        },

        scrollToEnd : function(){
            if(this.filteredUnsystemEvents.length){
                this.scrollToEvent(this.filteredUnsystemEvents[0].uid)
            }
            else{

                const container = this.$refs["events"];

                if(!container) return

                this.scroll(container.scrollHeight - container.clientHeight)

            }

        },

        scroll(s) {
			const container = this.$refs["events"];

            if(!container) return

			if (container.scrolling) {
				container.scrolling(-1, s);
			} else {
				container.scrollTop = s;
			}
		},

        

        componentscrolling : function(e){
            this.$emit('componentscrolling', e)

            var scroll = e.target.scrollTop

            if (scroll < this.lastScroll){
            }

            this.lastScroll = e.target.scrollTop

            if (this.needload()){

                var d = e.target.scrollHeight - e.target.scrollTop

                this.loadEvents().then(() => {
                    this.$nextTick(() => {
                        window.requestAnimationFrame(() => {
                            e.target.scrollTop = e.target.scrollHeight - d
                        })
                        
                    })
                })

                
            }
            
        },  

        
        finishStory : function(){

            if(this.toBottomButton && this.toBottomButton != 'end' && !this.playlist && this.storyview){

                var umi = this.toBottomButton

                this.$store.commit('delayedAction', {
                    time : 5000,
                    text : 'snippity.finishStory',
                    action : () => {
                        this.scrollToEvent(umi)
                    }
                })
                
            }
            
            
        },

        sendText : function(text){
            var m = text

            this.core.chats.api.sendMessagesToRoom(this.id, {
                data : {
                    text : m,
                    type : 'message'
                }
            }).then(() => {

                setTimeout(() => {
                    this.scrollToEnd(0)
                }, 200)
                

            }).catch(e => {

                this.$store.commit('icon', {
					icon: 'error',
					message: this.$t(e.error || "errors.general")
				})

                this.$refs.forminput.set(m)
                
                //this.textareavalue = m
            })

            //this.textareavalue = ''

            
        },
    },
}